export default __webpack_public_path__ + "static/media/chair.0d322bc7.png";